import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  subscribeToMailingList,
  unsubscribeFromMailingList,
} from "../api/mailingListService";

export const useMailingListSubscriptionCrud = () => {
  const queryClient = useQueryClient();

  const subscribeMutation = useMutation({
    mutationFn: subscribeToMailingList,
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ["mailing-lists"],
      });
    },
  });

  const unsubscribeMutation = useMutation({
    mutationFn: unsubscribeFromMailingList,
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ["mailing-lists"],
      });
    },
  });

  return {
    subscribeMutation,
    unsubscribeMutation,
  };
};
